import {
  BusinessLogicParameter,
  LabelGroup,
  LabelGroupType,
  NormalizedBusinessLogicRule,
  NormalizedLabelGroup,
  ParameterType
} from '@/types/businessLogic'
import { convertCoordinatesToString } from './coordinates'

const buildLabelGroup = (
  normalizedLabelGroup: NormalizedLabelGroup
): LabelGroup => {
  const {
    type,
    label_id,
    threshold,
    sub_label_operator,
    sub_label_ids,
    min_dwell_time,
    alert_on_exit,
    alert_on_unique,
    is_ocr_enabled,
    ocr_label_ids,
    is_qr_barcode_enabled,
    qr_barcode_label_ids,
    classification_label_id
  } = normalizedLabelGroup

  const labelGroup: LabelGroup = {
    type,
    label_id,
    threshold,
    sub_labels:
      type === LabelGroupType.Group
        ? [
            {
              operator: sub_label_operator,
              label_ids: sub_label_ids
            }
          ]
        : [],
    min_dwell_time,
    alert_on_exit,
    alert_on_unique,
    ocr_label_ids: is_ocr_enabled ? ocr_label_ids : [],
    machine_code_label_ids: is_qr_barcode_enabled ? qr_barcode_label_ids : [],
    // Maps label IDs to classification label IDs
    //
    // Frontend: only supports parent classes
    // Backend: supports all classes (parent and child)
    //
    // Example structure:
    // {
    //   [parent_label_id]: classification_label_id_1,
    //   [child_label_id_1]: classification_label_id_2,
    //   [child_label_id_2]: classification_label_id_3
    // }
    classification_tags: classification_label_id
      ? { [label_id]: classification_label_id }
      : null
  }

  return labelGroup
}

type BuildBuisnessLogicParameterParams = {
  type: ParameterType
  coordinates: number[][]
  name: string
  alert: boolean
  upload_video: boolean
  upload_bbox_video: boolean
  rules: NormalizedBusinessLogicRule[]
}

export const buildBuisnessLogicParameter = ({
  type,
  coordinates,
  name,
  alert,
  upload_video,
  upload_bbox_video,
  rules
}: BuildBuisnessLogicParameterParams): BusinessLogicParameter => {
  return {
    parameter_type: type,
    coordinates: convertCoordinatesToString(coordinates),
    name,
    event: {
      alert,
      upload_video,
      upload_bbox_video
    },
    rules: rules.map((rule) => {
      return {
        operator: rule.operator,
        label_groups: rule.label_groups.map((normalizedLabelGroup) =>
          buildLabelGroup(normalizedLabelGroup)
        )
      }
    })
  }
}
